import React, { useEffect } from 'react';
import { useParams, Route, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import {
    AnimatedPageLoader,
    ErrorAlert,
    VerticalFlex,
    HorizontalFlex,
    PadContainer,
    InfoAlert,
    HighlightedSection,
    Title,
} from 'smartsuite-ui';
import { useQuery } from 'react-query';
import BagList from './BagList';
import LocationAreaPanel from './LocationAreaPanel';
import {
    buildFlightListQuery,
    buildBagLocationsQuery,
    buildConfiguredLocationsQuery,
} from '../../utils/apiUtils';

export default function BagLocations(props) {
    let { path } = useRouteMatch();
    const { flightId } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [flightId]);

    const { data: flightList } = useQuery(
        buildFlightListQuery(
            props.airlineCode,
            props.selectedStation,
            props.outboundTerminal
        )
    );

    const {
        isLoading,
        isError,
        data: bagCounts,
        error,
    } = useQuery(buildBagLocationsQuery(flightId));

    const {
        isLoading: isConfiguredLocationsLoading,
        data: configuredLocations,
    } = useQuery(buildConfiguredLocationsQuery(flightId));

    function renderFlightHeader(flightData) {
        if (!flightData?.flightIdentifier) {
            return null;
        }

        return (
            <HighlightedSection>
                <PadContainer cssClassModifiers={['pad-medium']}>
                    <Title cssClassModifiers={['size-small']}>
                        {flightData.flightIdentifier}
                    </Title>
                </PadContainer>
            </HighlightedSection>
        );
    }

    function onClick() {}

    const flight = flightList?.find(
        (x) => x.id.toString() === flightId?.toString()
    );

    if (!flight) {
        return <InfoAlert>Select Flight</InfoAlert>;
    }

    if (isLoading || isConfiguredLocationsLoading) {
        return <AnimatedPageLoader />;
    }

    if (isError) {
        return <ErrorAlert>Something went wrong</ErrorAlert>;
    }

    const locationSummaries = configuredLocations.map((configuredLocation) => ({
        id: configuredLocation.locationAreaId,
        description: configuredLocation.locationAreaName,
        bagCount: bagCounts.filter(
            (x) => x.locationAreaId == configuredLocation.locationAreaId
        ).length,
        bags: bagCounts
            .filter(
                (x) => x.locationAreaId == configuredLocation.locationAreaId
            )
            .map((bag) => ({
                id: bag.masterBagId,
                bagTag: bag.bagTag,
                lastSeenDevice: bag.lastSeenDevice,
                lastSeenTimeLocal: bag.lastSeenTimeLocal,
            })),
    }));

    return (
        <div className="bag-locations">
            <div className="locations-areas">
                {renderFlightHeader(flight)}
                <PadContainer cssClassModifiers={['pad-small']} />
                {locationSummaries.map((locationSummary) => (
                    <LocationAreaPanel
                        key={locationSummary.id}
                        locationSummary={locationSummary}
                        onClick={onClick}
                    />
                ))}
            </div>
            <div className="bag-list">
                <Route path={`${path}/:locationId?`}>
                    <BagList locationSummaries={locationSummaries} />
                </Route>
            </div>
        </div>
    );
}

BagLocations.propTypes = {
    flightId: PropTypes.string.isRequired,
};
